export default {
  contained: {
    padding: '8px !important',
    minWidth: 'unset',
  },
}



// WEBPACK FOOTER //
// ./src/Components/Form/StyledIconButton/styles.js